<template>
    <div>
        <div class="d-flex justify-center mb-8">
            <v-btn-toggle
                v-model="tab"
            >
                <v-btn :value="0">
                    Credit
                </v-btn>
                <v-btn :value="1">
                    Withdraw
                </v-btn>
            </v-btn-toggle>
        </div>

        <v-tabs-items
            v-model="tab"
            class="transparent"
        >
            <v-tab-item>
                <CreditRefTxTab />
            </v-tab-item>
            <v-tab-item>
                <WithdrawRefTxTab />
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
import CreditRefTxTab from './CreditRefTxTab.vue';
import WithdrawRefTxTab from './WithdrawRefTxTab.vue';

export default {
    components: {
        CreditRefTxTab,
        WithdrawRefTxTab,
    },
    data: () => ({
        tab: 0,
    }),
};
</script>
